export default () => {
  const data = {
    balance: [
      {
        title: 'arCore Balance',
        value: '1,210',
        total: '237,000',
      },
      {
        title: 'arNXM Balance',
        value: '346',
        total: '237,000',
      },
      {
        title: 'arShield Balance',
        value: '679',
        total: '237,000',
      },
    ],
    referredUsers: [
      {
        account: '0x923hf3jf..09',
        time: 'Jan 1st',
      },
      {
        account: '0x923hf3jf..09',
        time: 'Jan 2nd',
      },
      {
        account: '0x923hf3jf..09',
        time: 'Jan 3rd',
      },
      {
        account: '0x923hf3jf..09',
        time: 'Jan 3rd',
      },
      {
        account: '0x923hf3jf..09',
        time: 'Jan 3rd',
      },
      {
        account: '0x923hf3jf..09',
        time: 'Jan 3rd',
      },
    ],
    recentRewards: [
      {
        account: '0x923...09',
        protocol: 'arNXM',
        amount: '33',
      },
      {
        account: '0x923...09',
        protocol: 'arCore',
        amount: '20',
      },
      {
        account: '0x923...09',
        protocol: 'arCore',
        amount: '19',
      },
    ],
  }
  return data
}
